import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import InvestorHoldings from "./holdings";
import InvestorAllocation from "./allocations";
import OpenOrders from "./open_orders";
import HoldingJournalButton from "./holdingJournalButton";
import PlaceOrderButton from "./placeOrderButton";
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {connect} from "react-redux";

const styles = theme => ({
    sectionHeader:{
        position:'absolute',
        top:0,
        left:0,
        backgroundColor:'white',
        width: '100%',
        zIndex: 100,
        paddingTop: '5px',
    },
    tabs:{
        display:'inline-block',
        width:'100%',
        borderBottom:'2px solid #6a94ff',
        marginLeft:0,
        paddingLeft:0,

        '& li':{
            display:'inline-block',

            '& button':{
                margin:'1px',
                padding:'6px 12px',
                backgroundColor:'#383c42',
                color:'white'
            },
            '& button:hover':{
                backgroundColor:'#6a94ff',
            },
            '& button.active':{
                backgroundColor:'#6a94ff',
            }
        }
    },
    flex: {
        flex: 1,
    },
});

class Trading extends Component {
    state={
        activeTab:'open',
        activeHoldTab:'holdings'
    };

    changeTab = (e) => {
        this.setState({
            activeTab:e.target.id
        })
    };

    changeHoldTab = (e) => {
        this.setState({
            activeHoldTab:e.target.id
        })
    };

    render() {
        const {classes} = this.props;

        return (
            <div className={'flex-col flex h-full'}>

                <div className={'flex mr-1'} style={{height:'40%'}} >
                    <Paper className={'flex-1'} style={{position:'relative', margin:5}}>

                        <AppBar position="static" elevation={0} color={"default"} style={{boxShadow:'none'}}>
                            <Toolbar>
                                <Typography variant="title" color="inherit" className={classes.flex}>
                                    Holdings
                                </Typography>
                                {(this.props.user.role.includes('super') || this.props.user.role.includes('holding')) &&
                                    <HoldingJournalButton investor = {this.props.investor} />
                                }
                            </Toolbar>
                        </AppBar>

                            <div style={{overflow: 'auto', height: '100%', padding:5}}>
                                <InvestorHoldings investor={this.props.investor}/>
                            </div>
                    </Paper>

                    <Paper className={'flex-1 ml-1'} style={{position:'relative',margin:5}}>
                        <AppBar position="static" elevation={0} color={"default"}>
                            <Toolbar>
                                <Typography variant="title" color="inherit" className={classes.flex}>
                                    Allocation Requests
                                </Typography>
                            </Toolbar>
                        </AppBar>

                        <div style={{overflow: 'auto', height: '100%', padding: 5}}>
                            <InvestorAllocation investor={this.props.investor}/>
                        </div>
                    </Paper>
                </div>

                <div className={'flex mr-1'} style={{height:'60%',overflow:'auto'}}>
                    <Paper className={'flex-1'} style={{position:'relative', margin:5}}>
                        <AppBar position="static" elevation={0} color={"default"}>
                            <Toolbar>
                                <Typography variant="title" color="inherit" className={classes.flex}>
                                    Orders
                                </Typography>
                                {(this.props.user.role.includes('super') || this.props.user.role.includes('ordering')) &&
                                <PlaceOrderButton investor = {this.props.investor} />
                                }
                            </Toolbar>
                        </AppBar>

                        <div className={classes.sectionHeader} style={{position:'relative',padding: '5px', marginTop:'6px'}}>
                            <ul className={classes.tabs}>
                                <li><button className={(this.state.activeTab === 'open') ? 'active' : ''} onClick={this.changeTab} id={'open'}>Open</button></li>
                                <li><button className={(this.state.activeTab === 'matched') ? 'active' : ''} onClick={this.changeTab} id={'matched'}>Matched</button></li>
                                <li><button className={(this.state.activeTab === 'cancelled') ? 'active' : ''} onClick={this.changeTab} id={'cancelled'}>Cancelled</button></li>
                            </ul>
                        </div>
                        {(this.state.activeTab === 'open') &&
                        <div style={{overflow: 'auto', padding: '5px'}}>
                            <OpenOrders investor={this.props.investor} _state={0}/>
                        </div>
                        }
                        {(this.state.activeTab === 'matched') &&
                        <div style={{overflow: 'auto', padding: '5px'}}>
                            <OpenOrders investor={this.props.investor} _state={1}/>
                        </div>
                        }
                        {(this.state.activeTab === 'cancelled') &&
                        <div style={{overflow: 'auto', padding: '5px'}}>
                            <OpenOrders investor={this.props.investor} _state={3}/>
                        </div>
                        }
                    </Paper>
                </div>
            </div>
        )
    }
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(Trading))));
